/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RapportenInputs */

const nl_nav_rapporten = /** @type {(inputs: Nav_RapportenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporten`)
};

/**

* @param {Nav_RapportenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_rapporten = /** @type {((inputs?: Nav_RapportenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RapportenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_rapporten(inputs)
});
export { nav_rapporten as "nav.rapporten" }